// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

const RecalcCalculate = lazy(
  () => import('pages/recalculations/calculate/RecalcCalculate')
);

const RecalcCalculateRoute = (
  <Route path={routeName.recalcCalculate}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.PAYOUTREVIEWER_DASHBOARD,
            PrivateRouteConst.MY_TASK,
          ]}
        >
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <RecalcCalculate />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RecalcCalculateRoute;
